<template>
  <div class="task-list">
    <div class="yj-sheet-query">
      <header class="header wrapper">
        <span class="query-label">模板名称：</span>
        <el-input size="mini" style="width:200px" placeholder="请输入模板名称" v-model="templateName" clearable></el-input>
        <span class="query-label">创建人：</span>
        <el-select filterable clearable placeholder="选择创建人" size="mini" v-model="createrId">
          <el-option v-for="(u, i) in userList" :key="i" :label="u.nickName" :value="u.id"></el-option>
        </el-select>
        <el-button type="primary" plain size="mini" @click="handleSearch">查询</el-button>
        <div class="yj-query-r">
          <span class="yj-blue-btn" @click="openCreate('btn')">
            <i class="el-icon-plus" style="margin-right: 4px;"></i>创建新的模板
          </span>
        </div>
      </header>
    </div>
    <div class="main wrapper">
      <div class="data-container" v-loading="loading">
        <el-table :data="dataList" size="normal">
          <el-table-column align="center" label="模板名称" prop="templateName" min-width="200"></el-table-column>
          <el-table-column align="center" label="阅卷方式">
            <template slot-scope="scope">
              {{ scope.row.isHenCode ? '有痕阅卷' : '网络阅卷' }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="年级" prop="gradeName">
            <template slot-scope="scope">
              <el-dropdown v-if="isAdmin(scope.row)" :key="'grade' + scope.row.id" @command="updateGrade($event, scope.row)">
                <span style="color: #2877FF;">
                  {{ scope.row.gradeName }}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(opt,index) in gradeList" :key="index" :command="opt.id">{{ opt.gradeName }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span v-else>{{ scope.row.gradeName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="学科" prop="subjectName"></el-table-column>
          <el-table-column align="center" label="栏数" prop="columnNum"></el-table-column>
          <el-table-column align="center" width="150" label="客观题/主观题数量" prop="objectiveQuestionNum">
            <template slot-scope="scope">
              {{ scope.row.objectiveQuestionNum }}/{{ scope.row.subjectiveQuestionNum }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="创建人" prop="createrName"></el-table-column>
          <el-table-column align="center" label="创建时间" width="150" prop="createTime">
            <template slot-scope="scope">{{ scope.row.createTime | formatDate }}</template>
          </el-table-column>
          <el-table-column align="center" label="操作" min-width="180">
            <template slot-scope="scope">
              <div class="operate">
                <div>
                  <el-button type="text" @click="taskDetail(scope.row)" size="normal">查看</el-button>
                  <el-button v-if="isAdmin(scope.row)" type="text" @click="update(scope.row)" size="normal">编辑</el-button>
                  <el-button type="text" @click="copy(scope.row)" size="normal">复用</el-button>
                </div>
                <div v-if="isAdmin(scope.row)">
                  <span> {{ scope.row.isOpen ? '已公开' : '已隐藏' }} </span>
                  <el-switch v-model="scope.row.isOpen" @change="changeOpenStates(scope.row)"></el-switch>
                  <el-button type="text" size="normal" style="color: #333333;"
                    @click="delTemplate(scope.row)">删除</el-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <zj-pagination :page="{ current: currentPage, size: pageSize, total: total }"
            @current-change="handleCurrentChange"></zj-pagination>
        </div>
      </div>
    </div>

    <yue-dialog title="选择年级和学科" :visible.sync="newVisible" width="500px" :close-on-click-modal="false"
      :close-on-press-escape="false" :before-close="closeCreate">
      <el-form @submit.native.prevent style="padding:0 30px">
        <el-form-item label="年级：">
          <el-select style="width:250px" value-key="id" v-model="grade" placeholder="请选择年级">
            <el-option v-for="(g, i) in gradeList" :key="i" :label="g.gradeName" :value="g"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学科：">
          <el-select style="width:250px" v-model="subjectCode" placeholder="请选择学科">
            <el-option v-for="(s, i) in subjectList" :key="i" :label="s.dicName" :value="s.dicCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板：">
          <el-select style="width:250px" v-model="templateId" placeholder="请选择模板">
            <el-option v-for="(t, i) in templateList" :key="i" :label="t.templateName" :value="t.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:center">
        <el-button size="small" @click="closeCreate">取 消</el-button>
        <el-button size="small" type="primary" @click="createNew">确 定</el-button>
      </div>
    </yue-dialog>
    <yue-dialog title="请输入复用的答题卡名称" :visible.sync="reuseVisible" width="500px">
      <el-form @submit.native.prevent style="padding:0 30px">
        <el-form-item label="答题卡名称：">
          <el-input style="width:250px" v-model="reuseName">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:center">
        <el-button size="small" @click="reuseVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="reuseTemplate">确 定</el-button>
      </div>
    </yue-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import util from "@/utils/util.js";
import {
  listSystemTemplate,
  updateExamOpenStates,
  updateSheetGrade,
  reuseTemplate,
  delTemplate
} from "@/api/tool";
import {
  listExamTemplate
} from "@/api/exam/exam";
import { getSubjectList, getTeachers } from "@/api/api";
import ZjPagination from '../../zujuan/components/ZjPagination.vue';
import exam_enum from "../../../utils/exam_enum";
export default {
  components: { ZjPagination },
  data () {
    return {
      templateId: '',
      templateList: [],
      reuseVisible: false,
      reuseName: '',
      subjectList: [],
      grade: {},
      subjectCode: "",
      newVisible: false,
      createrId: "",
      userList: [],
      templateName: "",
      schoolId: "",
      loading: false,
      //分页字段
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dataList: [],
    };
  },
  watch: {
    grade (val) {
      this.subjectList = [];
      this.subjectCode = "";
      val.id && this._getSubjectList();
    },
    subjectCode (val) {
      val && this.listSystemTemplate()
    }
  },
  mounted () {
    this.jumpNext()
    this.schoolId = this.userInfo.schoolId;
    this.listSimpleTeacher();
    this._getList();
  },
  filters: {
    formatDate (val) {
      return util.formatDate(val, "ymdhi");
    }
  },

  methods: {
    isAdmin (row) {
      return this.userInfo.isAdmin || this.userInfo.userId === row.createrId
    },
    jumpNext () {
      const menus = JSON.parse(window.YJ_SCHOOL_STORAGE.getItem("menus"));
      // 如果用户没有菜单权限或菜单个数为1，进到这个页面，将组卷模式下header移除掉
      if (this.$store.getters.isZujuan && (!menus || menus.length < 2)) {
        this.$el.parentElement.style.paddingTop = '4px'
        const header = document.body.querySelector('.zujuan-header')
        if (header) {
          header.parentElement.removeChild(header)
        }
      }
      const { paperId, gradeId, courseId } = this.$route.query
      if (paperId) {
        const grade = this.gradeList.find(item => item.gradeNum + '' === gradeId)
        if (grade) {
          this.grade = grade
        } else {
          this.grade = this.gradeList[0]
        }
        if (courseId) {
          this.subjectCode = courseId
        }
        this.openPosition = 'route'
        this.createNew()
      }
    },
    closeCreate: function () {
      if (this.openPosition === 'route' && this.$store.getters.isZujuan) {
        if (top === self) {
          this.newVisible = false
        } else {
          top.window.close()
        }
      } else {
        this.newVisible = false
      }
    },
    openCreate: function (position) {
      this.openPosition = position
      this.newVisible = true
    },
    // 获取科目
    async _getSubjectList () {
      let params = {
        schoolId: this.userInfo.schoolId,
        gradeId: this.grade.id
      };
      let resp = await getSubjectList(params);

      if (resp.code == 200) {
        let arr = [];
        let data = resp.result.school_dic;
        for (let key in data) {
          const subject = data[key]
          const courseId = this.getCourseId(subject.dicCode)
          if (courseId + '' === this.$route.query.courseId) {
            this.subjectCode = subject.dicCode
          }
          arr.push(subject);
        }
        if ((!this.subjectCode || this.subjectCode.length === 0) && arr.length > 0) {
          this.subjectCode = arr[0].dicCode
        }
        this.subjectList = arr;
      }
    },
    createNew () {
      if (this.grade.id && this.subjectCode) {
        this.newVisible = false
        const route = {
          path: '/card/create',
          query: {
            istemplate: 1,
            gradeId: this.grade.id,
            grade: this.grade.gradeNum,
            subjectCode: this.subjectCode,
            templateId: this.templateId
          }
        }
        if (this.openPosition === 'route') {
          route.query.back2Zj = true
          route.query.scene = this.$route.query.scene
          route.path = '/card/zujuan'
          route.query.paperId = this.$route.query.paperId
        }
        this.$router.push(route);
      } else {
        return this.$message.warning('请选择年级和学科')
      }
    },
    handleSearch () {
      this.currentPage = 1;
      this._getList();
    },
    update (row) {
      const startTime = new Date('2023/12/28').getTime()
      if (startTime - row.updateTime > 0) {
        const message = `<p>您现在点击的是旧版答题卡，若需预览请点击【查看】；若需编辑，进入后需重新设置学生信息，确认编辑答题卡？</p>
        <p>⚠️ 注意，若该答题卡已应用于考试，请勿编辑！</p>`
        this.$confirm(message, '答题卡功能更新啦，欢迎体验！', { dangerouslyUseHTMLString: true }).then(() => {
          this.jumpEdit(row)
        }).catch(() => { });
      } else {
        this.jumpEdit(row)
      }
    },
    jumpEdit (row) {
      const route = {
        path: '/card/create',
        query: {
          istemplate: 1,
          gradeId: row.gradeId,
          grade: row.grade,
          subjectCode: row.subjectCode,
          examSheetId: row.id,
          sheetName: row.templateName,
          isEdit: 1
        }
      }
      if (row.paperSnapshotId) {
        route.path = '/card/zujuan'
        route.query.paperSnapshotId = row.paperSnapshotId
      }
      this.$router.push(route);
    },
    copy (row) {
      this.currentRow = row;
      this.reuseName = row.templateName
      this.reuseVisible = true
    },
    async reuseTemplate () {
      if (this.reuseName.trim == '') return this.$message.warning('请输入模板名称')
      let res = await reuseTemplate({
        id: this.currentRow.id,
        templateName: this.reuseName,
        userId: this.userInfo.userId
      });
      if (res.success) {
        this.$message.success("复用成功！");
        this.reuseVisible = false
        this.handleSearch()
      } else {
        this.$message.error(res.message);
      }
    },
    taskDetail (row) {
      window.open(row.pdfPath)
    },
    async _getList () {
      this.loading = true;
      let res = await listSystemTemplate({
        createrId: this.createrId,
        isOnSal: "ONLINE",
        isSchoolTemplate: 1,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        schoolId: this.schoolId,
        templateName: this.templateName
      });
      this.loading = false;
      if (res.success) {
        for (let item of res.body.items) {
          item.gradeName = this._getGradeName(item.grade)
          item.isHenCode = exam_enum.getCodeByKey(item.isHen)
          item.isOpen = item.openStatus === exam_enum.examEnum.OPEN.name
        }

        this.dataList = res.body.items;
        this.total = res.body.totalSize
      } else {
        this.$message.error(res.message);
      }
    },

    _getGradeName (gradeNum) {
      if (!this.gradeList) return gradeNum
      let grade = this.gradeList.find(item => item.gradeNum === gradeNum)
      if (!grade) {
        return util.convertGradeName(gradeNum)
      }
      return grade.gradeName
    },

    async listSystemTemplate () {
      let res = await listExamTemplate({
        grade: this.grade.gradeNum,
        subjectCode: this.subjectCode,
        isSchoolTemplate: false,
        isOnSal: "ONLINE",
        school: 0,
      });
      if (res.success) {
        for (let item of res.body) {
          item.isOpen = item.openStatus === exam_enum.examEnum.OPEN.name
        }

        this.templateList = res.body;
        this.templateList.unshift({
          id: "",
          templateName: "自制答题卡"
        });
      } else {
        this.templateList = [
          {
            id: "",
            templateName: "自制答题卡"
          }
        ];
        this.$message.error(res.message);
      }
    },
    async listSimpleTeacher () {
      let res = await getTeachers({
        schoolId: this.schoolId,
        useStatus: 1,
        classType: 0,
        currentPage: 1,
        pageSize: 9999
      });
      if (res.body) {
        this.userList = res.body.items;
        this.userList.unshift({
          id: "",
          nickName: "全部"
        });
      } else {
        this.userList = [];
        this.$message.error(res.message);
      }
    },
    async delTemplate (row) {
      let msg =
        row.createrId == this.userInfo.userId
          ? "答题卡模板删除后不可恢复，是否确认删除？"
          : "当前答题卡模板并非本人创建，删除后不可恢复,是否确认删除？";
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await delTemplate({
            id: row.id
          });
          if (res.success) {
            this.$message.success("删除成功");
            this._getList();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => { });
    },

    //分页处理
    handleSizeChange (val) {
      this.pageSize = val;
      this._getList();
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      this._getList();
    },
    changeOpenStates (row) {
      let params = {
        examId: row.id,
        type: row.isOpen ? "OPEN" : "SELF"
      }
      updateExamOpenStates(params).then(resp => {
        if (!resp.success) {
          row.isOpen = !row.isOpen
        }
      })
    },
    updateGrade (gradeId, row) {
      updateSheetGrade({ id: row.id, gradeId }).then(resp => {
        if (resp.success) {
          const grade = this.gradeList.find(item => item.id === gradeId)
          row.grade = grade.gradeNum
          row.gradeId = grade.id
          row.gradeName = grade.gradeName
        }
      })
    }
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      gradeList: 'getGradeList'
    })
  }
};
</script>

<style scoped lang="scss">
.yj-sheet-query {
  height: 40px;
  background: white;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  margin-top: 1px;
}

.yj-sheet-query ::v-deep .el-select,
.yj-sheet-query ::v-deep .el-input--mini .el-input__inner {
  height: 26px;
  font-size: 14px;
  color: #999999;
}

.yj-sheet-query ::v-deep .el-input--mini .el-input__inner {
  padding: 0 10px;
}

.yj-sheet-query ::v-deep .el-button--primary:not(.is-disabled).is-plain {
  background-color: white;
  color: #2877FF;
  border-color: #2877FF;
  height: 26px;
  font-size: 14px;
  line-height: 12px;
  border-radius: 4px;
}

.query-label {
  color: #333;
  font-size: 14px;
  margin-left: 15px;
}


.task-list .wrapper {
  width: 1200px;
  margin: 0 auto;
}

.task-list .yj-query-r {
  float: right;
  padding-right: 15px;
}

.breadcrumb {
  height: 45px;
  line-height: 45px;

  .el-breadcrumb {
    display: inline-block;
    padding: 0 18px;
  }
}

.main {
  min-height: calc(100vh - 170px);
  background: #fff;

  .data-container {
    background-color: #fff;
    padding: 10px 0px 20px;
    border-radius: 6px;
    margin: 10px 30px;

    .operate {}
  }

  .task {
    .head {
      width: 450px;
      height: 50px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .head-title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        h3 {
          width: 0;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #2877FF;
          font-size: 20px;
        }

        span {
          width: 145px;
          color: #2877FF;
          font-size: 16px;
        }
      }

      .head-label {
        display: flex;
        justify-content: space-between;

        span {
          font-size: 16px;
          color: #333;
        }
      }
    }

    .tail {
      height: 50px;
      line-height: 50px;
    }
  }

  .pagination {
    margin-bottom: 10px;

    .el-pagination {
      padding-right: 0;
    }
  }
}

// 无数据
.no-data {
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 100px;
    height: 79px;
  }

  p {
    margin-top: 15px;
    color: #999;
  }
}

.pagination {
  padding-top: 20px;
  text-align: right;
  padding: 10px 0 20px;

  .el-pagination {
    padding-right: 0;
  }
}
</style>

<style lang="scss">
.task-list {
  .export-form {
    text-align: center;

    .el-dialog__body {
      padding: 20px 20px 0;

      h3 {
        text-align: center;
        font-size: $font-size-large;
        color: #333;
        margin: 25px 0;
      }
    }

    .el-dialog__footer {
      text-align: center !important;
    }
  }
}

.sheet-list_route .container {
  width: 100% !important;
  margin: auto !important;
  padding-top: 54px !important;
}
</style>